export default "__VITE_ASSET__CJ_691tu__"